import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Menu, Input, Icon } from 'semantic-ui-react';
import { openStaffModal } from '../actions';

class StaffMenu extends Component {

    handleFilterClick(e) {
        console.log('Filter clicked');
    }

    handleAddStaff = (e) => {
        this.props.openStaffModal(true);
    }

    render() {
        return (
            <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }} >
                {/* <Menu.Item>
                    <Input placeholder='Search...' />
                </Menu.Item> */}
                <Menu.Item name='filter' onClick={this.handleFilterClick.bind(this)} disabled>
                    <Icon name='filter' />
                    Filter
                </Menu.Item>
                <Menu.Item name='add' onClick={this.handleAddStaff.bind(this)}>
                    <Icon name='add user' />
                    Add Staff
                </Menu.Item>
            </Menu>
        )
    }
}

const mapStateToProps = ({staff}) => {
    return { staff }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        openStaffModal: openStaffModal
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(StaffMenu);
